<template>
  <div class="" style="height:100%">
    <span class="h3 heading-1">
      Course Details
    </span>
    <v-row style="margin: 0px;height: calc(100% - 54px);">
      <v-col cols="3 course-sidepanel border-right-1 pr-0 pt-0 pl-0" style="overflow-y: auto; height: 100%;">
        <v-tabs v-model="tab" class="course-view-wrap" vertical>
          <v-tab
            @click="getCourseDetails(event)"
            v-for="(event, i) in eventList"
            :key="i"
            class="tab-name"
          >
            <p>{{ event.EventFullName }}</p>
          </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="9 course-details-right">
        <div class="tab-details-heading">
          <h2>{{currentEvent?currentEvent.EventFullName:""}}</h2>
        </div>
        <v-row
          class="fill-height"
          v-if="isLoading"
          style="min-height:70vh"
          align="center"
          justify="center"
        >
           <v-progress-circular size="80" indeterminate color="primary" />
        </v-row>
        <div v-else-if="eventDetails && eventDetails.description">
          <div class="table-border" v-html="eventDetails.description"></div>
        </div>
        <v-row
          style="min-height:70vh"
          align="center"
          justify="center"
          class="fill-height"
          v-else
        >
          <div class="no-course-details">
            <v-icon color="#8a8a8a" size="80px">mdi-school</v-icon>
            <p class="no-data-text">No data available</p>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<style lang="scss">
// .course-view-wrap {
//   border: 1px solid #cbcbcb;
//   border-right: 0;
// }
// .border-right-1 {
//   border-right: 1px solid #cbcbcb;
// }
.course-view-wrap .v-tab {
  max-width: 100% !important;
  justify-content: flex-start !important;
  background: #ffffff;
  border-bottom: 1px solid #cbcbcb;
}
.course-view-wrap .v-tab {
    border-bottom: 0 !important;
}

.course-view-wrap .v-tab.v-tab--active {
  background: transparent;
  position: relative;
  border-right: 0;
  background-color:#f6f7f9;
}
.table-border table {
    width: 100% !important;
}
.table-border table tbody tr > td {
    border: 1px solid #cbcbcb;
    padding: 0.75rem;
    font-size: 1.15rem;
    line-height: 21px;
    font-weight: 300;
}
.v-dialog.client-dialog {
    box-shadow: none !important;
}
.tab-name p {
    margin: 0 !important;
    font-size: 14px;
    font-weight: 400;
    color: #4a4a4a;
}
.tab-name.v-tab--active p {
    color: #000;
    font-weight: 600;
}
.course-view-wrap.v-tabs--vertical > .v-tabs-bar .v-tab{display: block;height: inherit !important;padding: 25px 0px 25px 30px; text-align: left !important;}
.v-slide-group__content{flex: inherit !important; white-space: inherit !important;}
.tab-details-heading h2 {margin-bottom: 18px; font-size: 25px; line-height: 28px; color: #333; font-weight: 700; padding-bottom: 10px;}
.no-data-text {
    font-size: 18px;
    font-weight: 400;
    color: #8a8a8a;
    margin: 0;
}

.v-card__title{
  //display:none;
}
.v-tabs--vertical>.v-tabs-bar .v-tabs-slider{
  width: 10px;
  background-color:#404ea0;
}
.course-sidepanel .tab-name p{
  color:#000000;
  font-weight:600;
}
#ClientLobbyCard.v-card__text{
  margin:0px;
}
.heading-1{
  margin:0px;
  padding: 3px 0px 20px 40px;
  display:block;
  border-bottom: 1px solid #d1d4d8;
}
.course-details-right{
  padding: 30px;
  background-color:#f6f7f9;
}
.table-border{
  padding:30px;
  background-color:#ffffff;
  border-radius:15px;
}
.v-application .table-border ul,
.v-application .table-border ol,
.table-border ul,
.table-border ol{
  padding-left:15px !important;
}

.table-border ol li{
  display:list-item;
  list-style-type:disc;
}
.v-card v-sheet{
  border-radius:0px !important;
}
.table-border h6{
    font-size: 16px;
    padding-top: 15px;
}
.course-sidepanel .course-view-wrap{
	position: sticky; 
	align-self: flex-start;
	top: 0;
}
.no-course-details {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
</style>
<script>
import apiHandler from "../handler/edu_handler";
// import { bus } from "@/main";
export default {
  data() {
    return {
      currentEvent:"",
      eventList: [],
      tab: "",
      eventDetails: {},
      isLoading: false
    };
  },
  mounted() {
    this.getEventDetails();
  },
  methods: {
    getCourseDetails(currentEvent) {
      this.currentEvent=currentEvent
      this.isLoading = true;
      // bus.$emit("toggleLoader", true);
      let paramObj = {
        iid: "OA_UAT",
        cid: this.$store.state.client[0].id,
        eid: currentEvent.EventId
      };
      apiHandler
        .getSelectedCourseDetails(paramObj)
        .then(res => {
          this.eventDetails = res.data.result;
          this.isLoading = false;
          // bus.$emit("toggleLoader", false);
        })
        .catch(e => {
          this.isLoading = true;
          // bus.$emit("toggleLoader", true);
          console.log(e);
        });
    },
    getEventDetails() {
      var self = this;
      this.isLoading = true;

      
      
         this.$store.state.MappedEvent.forEach(element => {
            if (element.IsPublished) {
              this.eventList.push(element);
            }
          });
          if (this.eventList.length > 0) {
            self.getCourseDetails(this.eventList[0]);
          }
          this.isLoading = false;

   
      // let userObject = {
      //   instanceId: "OA_UAT",
      //   clientId: this.$store.state.client[0].id,
      //   attendeeId: this.$store.state.user[0].id
      // };
      // apiHandler
      //   .getCoursesByEvents(userObject)
      //   .then(result => {
      //     let res = result.data.data;
      //     res.forEach(element => {
      //       if (element.IsPublished) {
      //         this.eventList.push(element);
      //       }
      //     });
      //     if (this.eventList.length > 0) {
      //       self.getCourseDetails(this.eventList[0]);
      //     }
      //     this.isLoading = false;

      //   })
      //   .catch(err => {
      //     console.log(err);
      //     this.isLoading = false;
    
      //   });
    }
  }
};
</script>
